<template>
  <div class="about">
    <h1
      v-if="currentRoute === 'Welcome'"
      class="px-6 pt-6 pb-4 text-2xl sm:px-10 lg:px-16 title"
    >
      Welcome to POS Dashboards
    </h1>

    <div
      class="flex flex-wrap w-full px-6 mt-12 sm:px-10 lg:px-16"
      :style="{ 'max-height': 'calc(100vh - 150px)' }"
    >
      <template v-if="currentRoute === 'Welcome'">
        <div
          class="w-1/2 px-4 mb-8"
          :class="[!canAccessG40 ? 'pointer-events-none opacity-25' : '']"
        >
          <a
            href="javascript:void(0)"
            class="block px-10 py-10 font-semibold uppercase bg-white shadow-md hover:opacity-75"
            @click="onClickG40Monthly"
          >G40 Monthly</a>
        </div>
        <div
          class="w-1/2 px-4 mb-8"
          :class="[!canAccessG9Weekly ? 'pointer-events-none opacity-25' : '']"
        >
          <a
            href="javascript:void(0)"
            class="block px-10 py-10 font-semibold uppercase bg-white shadow-md hover:opacity-75"
            @click="onClickG9Weekly"
          >G9 Weekly</a>
        </div>

        <div
          class="w-1/2 px-4 mb-8"
          :class="[!canAccessG9SbsWeekly ? 'pointer-events-none opacity-25' : '']"
        >
          <a
            href="javascript:void(0)"
            class="block px-10 py-10 font-semibold uppercase bg-white shadow-md hover:opacity-75"
            @click="onClickSbsWeekly"
          >SBS Weekly</a>
        </div>
        <div
          class="w-1/2 px-4 mb-8"
        >
          <router-link
            :to="{name: 'Support'}"
            class="block px-10 py-10 font-semibold uppercase bg-white shadow-md hover:opacity-75"
            data-cy="general_info_access"
          >
            General Informations
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {computed, onMounted} from 'vue'
import { useRoute } from 'vue-router'
import useUI from '@c4-links/vuejs-utilities/src/features/useUI'
import useUser from '@c4-links/vuejs-utilities/src/features/useUser'
import useMode from '@/features/useMode'

export default {
  name: 'PosWelcomePage',

  setup () {
    const { showMenu, showSidebar} = useUI()
    const { modeG40Monthly, modeG9Weekly, modeSbsWeekly, modeSbsMonthly, mode } = useMode()
    const { user } = useUser()

    const currentRoute = computed(() => { return useRoute().name })

    onMounted(() => {
      showSidebar.value = false
    })

    const onClickG40Monthly = ()  => {
      mode.value = modeG40Monthly
      showMenu.value = true
    }

    const onClickG9Weekly = ()  => {
      mode.value = modeG9Weekly
      showMenu.value = true
    }

    const onClickSbsWeekly = ()  => {
      mode.value = modeSbsWeekly
      showMenu.value = true
    }

    const onClickSbsMonthly = ()  => {
      mode.value = modeSbsMonthly
      showMenu.value = true
    }

    return {
      showMenu,
      onClickG40Monthly,
      onClickG9Weekly,
      onClickSbsWeekly,
      onClickSbsMonthly,
      canAccessG40: user.value.pos_g40.active,
      canAccessG9Weekly: user.value.pos_g9_std_weekly.active,
      canAccessG9SbsWeekly: user.value.pos_g9_sbs_weekly.active,
      canAccessG9SbsMonthly: user.value.pos_g9_sbs_monthly.active,
      currentRoute
    }
  }
}
</script>

<style scoped>
.title {
  color: #3a4245;
}
</style>
